import type { Offset } from '@octopus-do/octopus-project-core'
import type { DraggableData } from 'react-draggable'

// Screen pixels the pointer must travel before a press is a drag rather than
// a click.
const DRAG_THRESHOLD = 5

// react-draggable reports a drag on any mouse movement, and with the 3px grid a
// hand that shakes by 2px while clicking already counts, so a move only counts
// once the pointer has travelled the threshold on screen (OCT-5164).
export const isDragMoved = (
  data: DraggableData,
  from: Offset,
  scale: number
): boolean =>
  Math.hypot(data.x - from.x, data.y - from.y) * scale >= DRAG_THRESHOLD
